module.exports = __webpack_public_path__ + "img/19_43.fae827f6.png";